export default __webpack_public_path__ + "static/pfizer-6ef1d7b00b2e1865c6c46f98905c87b3.png";